import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const TableRouteScheduleRow = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "table-contacts-row",
})``;
export const TableRouteScheduleStyled = styled.div`
  .MuiFormControl-root {
    width: 100%;
  }

  .route-schedule-list {
    .display-mode {
      transition: filter 0.55s ease-out;
    }
    button.add_button {
      transition: filter 0.55s ease-out;
    }
  }

  .route-schedule-list[data-inner-editing="true"] {
    .display-mode {
      filter: blur(3px) grayscale(100%) !important;
      pointer-events: none !important;
    }
    button.add_button {
      filter: blur(3px) grayscale(100%);
      pointer-events: none;
    }
  }

  .MuiListItem-root[${DATA_E2E_KEY}="route-schedule-item-edit"] {
    background-color: ${rydeColors.white};
    border-radius: 8px;
    margin: 12px 0;
  }
`;
